/**
 * What a contract is called wherever it is listed: its agreement name, else
 * the short description older contracts were given before the wizard stopped
 * asking for one (ClickUp 869fn1p3g).
 */
export const contractTitle = (contract: { contractName?: string | null; description?: string | null }) =>
  contract.contractName?.trim() || contract.description?.trim() || '';
